// Zone -> country name mapping, derived from the angular-timezone-selector-fixed
// package's data/zone.csv and data/cca2_to_country_name.csv (same source used by
// the legacy AngularJS timezone-selector directive), so the Angular timezone
// dropdown groups options the same way as the legacy one.
export const TIMEZONE_TO_COUNTRY: { [zone: string]: string } = {
    'Africa/Abidjan': "Cote D'Ivoire",
    'Africa/Accra': "Ghana",
    'Africa/Addis_Ababa': "Ethiopia",
    'Africa/Algiers': "Algeria",
    'Africa/Asmara': "Eritrea",
    'Africa/Bamako': "Mali",
    'Africa/Bangui': "Central African Republic",
    'Africa/Banjul': "Gambia",
    'Africa/Bissau': "Guinea-Bissau",
    'Africa/Blantyre': "Malawi",
    'Africa/Brazzaville': "Congo",
    'Africa/Bujumbura': "Burundi",
    'Africa/Cairo': "Egypt",
    'Africa/Casablanca': "Morocco",
    'Africa/Ceuta': "Spain",
    'Africa/Conakry': "Guinea",
    'Africa/Dakar': "Senegal",
    'Africa/Dar_es_Salaam': "Tanzania",
    'Africa/Djibouti': "Djibouti",
    'Africa/Douala': "Cameroon",
    'Africa/El_Aaiun': "Western Sahara",
    'Africa/Freetown': "Sierra Leone",
    'Africa/Gaborone': "Botswana",
    'Africa/Harare': "Zimbabwe",
    'Africa/Johannesburg': "South Africa",
    'Africa/Juba': "South Sudan",
    'Africa/Kampala': "Uganda",
    'Africa/Khartoum': "Sudan",
    'Africa/Kigali': "Rwanda",
    'Africa/Kinshasa': "Congo (Democratic Republic)",
    'Africa/Lagos': "Nigeria",
    'Africa/Libreville': "Gabon",
    'Africa/Lome': "Togo",
    'Africa/Luanda': "Angola",
    'Africa/Lubumbashi': "Congo (Democratic Republic)",
    'Africa/Lusaka': "Zambia",
    'Africa/Malabo': "Equatorial Guinea",
    'Africa/Maputo': "Mozambique",
    'Africa/Maseru': "Lesotho",
    'Africa/Mbabane': "Swaziland",
    'Africa/Mogadishu': "Somalia",
    'Africa/Monrovia': "Liberia",
    'Africa/Nairobi': "Kenya",
    'Africa/Ndjamena': "Chad",
    'Africa/Niamey': "Niger",
    'Africa/Nouakchott': "Mauritania",
    'Africa/Ouagadougou': "Burkina Faso",
    'Africa/Porto-Novo': "Benin",
    'Africa/Sao_Tome': "Sao Tome And Principe",
    'Africa/Tripoli': "Libyan Arab Jamahiriya",
    'Africa/Tunis': "Tunisia",
    'Africa/Windhoek': "Namibia",
    'America/Adak': "United States",
    'America/Anchorage': "United States",
    'America/Anguilla': "Anguilla",
    'America/Antigua': "Antigua And Barbuda",
    'America/Araguaina': "Brazil",
    'America/Argentina/Buenos_Aires': "Argentina",
    'America/Argentina/Catamarca': "Argentina",
    'America/Argentina/Cordoba': "Argentina",
    'America/Argentina/Jujuy': "Argentina",
    'America/Argentina/La_Rioja': "Argentina",
    'America/Argentina/Mendoza': "Argentina",
    'America/Argentina/Rio_Gallegos': "Argentina",
    'America/Argentina/Salta': "Argentina",
    'America/Argentina/San_Juan': "Argentina",
    'America/Argentina/San_Luis': "Argentina",
    'America/Argentina/Tucuman': "Argentina",
    'America/Argentina/Ushuaia': "Argentina",
    'America/Aruba': "Aruba",
    'America/Asuncion': "Paraguay",
    'America/Atikokan': "Canada",
    'America/Bahia': "Brazil",
    'America/Bahia_Banderas': "Mexico",
    'America/Barbados': "Barbados",
    'America/Belem': "Brazil",
    'America/Belize': "Belize",
    'America/Blanc-Sablon': "Canada",
    'America/Boa_Vista': "Brazil",
    'America/Bogota': "Colombia",
    'America/Boise': "United States",
    'America/Cambridge_Bay': "Canada",
    'America/Campo_Grande': "Brazil",
    'America/Cancun': "Mexico",
    'America/Caracas': "Venezuela",
    'America/Cayenne': "French Guiana",
    'America/Cayman': "Cayman Islands",
    'America/Chicago': "United States",
    'America/Chihuahua': "Mexico",
    'America/Costa_Rica': "Costa Rica",
    'America/Creston': "Canada",
    'America/Cuiaba': "Brazil",
    'America/Curacao': "Curacao",
    'America/Danmarkshavn': "Greenland",
    'America/Dawson': "Canada",
    'America/Dawson_Creek': "Canada",
    'America/Denver': "United States",
    'America/Detroit': "United States",
    'America/Dominica': "Dominica",
    'America/Edmonton': "Canada",
    'America/Eirunepe': "Brazil",
    'America/El_Salvador': "El Salvador",
    'America/Fortaleza': "Brazil",
    'America/Glace_Bay': "Canada",
    'America/Godthab': "Greenland",
    'America/Goose_Bay': "Canada",
    'America/Grand_Turk': "Turks And Caicos Islands",
    'America/Grenada': "Grenada",
    'America/Guadeloupe': "Guadeloupe",
    'America/Guatemala': "Guatemala",
    'America/Guayaquil': "Ecuador",
    'America/Guyana': "Guyana",
    'America/Halifax': "Canada",
    'America/Havana': "Cuba",
    'America/Hermosillo': "Mexico",
    'America/Indiana/Indianapolis': "United States",
    'America/Indiana/Knox': "United States",
    'America/Indiana/Marengo': "United States",
    'America/Indiana/Petersburg': "United States",
    'America/Indiana/Tell_City': "United States",
    'America/Indiana/Vevay': "United States",
    'America/Indiana/Vincennes': "United States",
    'America/Indiana/Winamac': "United States",
    'America/Inuvik': "Canada",
    'America/Iqaluit': "Canada",
    'America/Jamaica': "Jamaica",
    'America/Juneau': "United States",
    'America/Kentucky/Louisville': "United States",
    'America/Kentucky/Monticello': "United States",
    'America/Kralendijk': "Bonaire",
    'America/La_Paz': "Bolivia",
    'America/Lima': "Peru",
    'America/Los_Angeles': "United States",
    'America/Lower_Princes': "Sint Maarten",
    'America/Maceio': "Brazil",
    'America/Managua': "Nicaragua",
    'America/Manaus': "Brazil",
    'America/Marigot': "Saint Martin",
    'America/Martinique': "Martinique",
    'America/Matamoros': "Mexico",
    'America/Mazatlan': "Mexico",
    'America/Menominee': "United States",
    'America/Merida': "Mexico",
    'America/Metlakatla': "United States",
    'America/Mexico_City': "Mexico",
    'America/Miquelon': "Saint Pierre And Miquelon",
    'America/Moncton': "Canada",
    'America/Monterrey': "Mexico",
    'America/Montevideo': "Uruguay",
    'America/Montreal': "Canada",
    'America/Montserrat': "Montserrat",
    'America/Nassau': "Bahamas",
    'America/New_York': "United States",
    'America/Nipigon': "Canada",
    'America/Nome': "United States",
    'America/Noronha': "Brazil",
    'America/North_Dakota/Beulah': "United States",
    'America/North_Dakota/Center': "United States",
    'America/North_Dakota/New_Salem': "United States",
    'America/Ojinaga': "Mexico",
    'America/Panama': "Panama",
    'America/Pangnirtung': "Canada",
    'America/Paramaribo': "Suriname",
    'America/Phoenix': "United States",
    'America/Port-au-Prince': "Haiti",
    'America/Port_of_Spain': "Trinidad And Tobago",
    'America/Porto_Velho': "Brazil",
    'America/Puerto_Rico': "Puerto Rico",
    'America/Rainy_River': "Canada",
    'America/Rankin_Inlet': "Canada",
    'America/Recife': "Brazil",
    'America/Regina': "Canada",
    'America/Resolute': "Canada",
    'America/Rio_Branco': "Brazil",
    'America/Santa_Isabel': "Mexico",
    'America/Santarem': "Brazil",
    'America/Santiago': "Chile",
    'America/Santo_Domingo': "Dominican Republic",
    'America/Sao_Paulo': "Brazil",
    'America/Scoresbysund': "Greenland",
    'America/Sitka': "United States",
    'America/St_Barthelemy': "Saint Barthelemy",
    'America/St_Johns': "Canada",
    'America/St_Kitts': "Saint Kitts And Nevis",
    'America/St_Lucia': "Saint Lucia",
    'America/St_Thomas': "Virgin Islands (U.S.)",
    'America/St_Vincent': "Saint Vincent And Grenadines",
    'America/Swift_Current': "Canada",
    'America/Tegucigalpa': "Honduras",
    'America/Thule': "Greenland",
    'America/Thunder_Bay': "Canada",
    'America/Tijuana': "Mexico",
    'America/Toronto': "Canada",
    'America/Tortola': "Virgin Islands (British)",
    'America/Vancouver': "Canada",
    'America/Whitehorse': "Canada",
    'America/Winnipeg': "Canada",
    'America/Yakutat': "United States",
    'America/Yellowknife': "Canada",
    'Antarctica/Casey': "Antarctica",
    'Antarctica/Davis': "Antarctica",
    'Antarctica/DumontDUrville': "Antarctica",
    'Antarctica/Macquarie': "Australia",
    'Antarctica/Mawson': "Antarctica",
    'Antarctica/McMurdo': "Antarctica",
    'Antarctica/Palmer': "Antarctica",
    'Antarctica/Rothera': "Antarctica",
    'Antarctica/Syowa': "Antarctica",
    'Antarctica/Troll': "Antarctica",
    'Antarctica/Vostok': "Antarctica",
    'Arctic/Longyearbyen': "Svalbard And Jan Mayen",
    'Asia/Aden': "Yemen",
    'Asia/Almaty': "Kazakhstan",
    'Asia/Amman': "Jordan",
    'Asia/Anadyr': "Russian Federation",
    'Asia/Aqtau': "Kazakhstan",
    'Asia/Aqtobe': "Kazakhstan",
    'Asia/Ashgabat': "Turkmenistan",
    'Asia/Baghdad': "Iraq",
    'Asia/Bahrain': "Bahrain",
    'Asia/Baku': "Azerbaijan",
    'Asia/Bangkok': "Thailand",
    'Asia/Beirut': "Lebanon",
    'Asia/Bishkek': "Kyrgyzstan",
    'Asia/Brunei': "Brunei Darussalam",
    'Asia/Choibalsan': "Mongolia",
    'Asia/Chongqing': "China",
    'Asia/Colombo': "Sri Lanka",
    'Asia/Damascus': "Syrian Arab Republic",
    'Asia/Dhaka': "Bangladesh",
    'Asia/Dili': "Timor-Leste",
    'Asia/Dubai': "United Arab Emirates",
    'Asia/Dushanbe': "Tajikistan",
    'Asia/Gaza': "Palestinian Territory (Occupied)",
    'Asia/Harbin': "China",
    'Asia/Hebron': "Palestinian Territory (Occupied)",
    'Asia/Ho_Chi_Minh': "Viet Nam",
    'Asia/Hong_Kong': "Hong Kong",
    'Asia/Hovd': "Mongolia",
    'Asia/Irkutsk': "Russian Federation",
    'Asia/Jakarta': "Indonesia",
    'Asia/Jayapura': "Indonesia",
    'Asia/Jerusalem': "Israel",
    'Asia/Kabul': "Afghanistan",
    'Asia/Kamchatka': "Russian Federation",
    'Asia/Karachi': "Pakistan",
    'Asia/Kashgar': "China",
    'Asia/Kathmandu': "Nepal",
    'Asia/Khandyga': "Russian Federation",
    'Asia/Kolkata': "India",
    'Asia/Krasnoyarsk': "Russian Federation",
    'Asia/Kuala_Lumpur': "Malaysia",
    'Asia/Kuching': "Malaysia",
    'Asia/Kuwait': "Kuwait",
    'Asia/Macau': "Macao",
    'Asia/Magadan': "Russian Federation",
    'Asia/Makassar': "Indonesia",
    'Asia/Manila': "Philippines",
    'Asia/Muscat': "Oman",
    'Asia/Nicosia': "Cyprus",
    'Asia/Novokuznetsk': "Russian Federation",
    'Asia/Novosibirsk': "Russian Federation",
    'Asia/Omsk': "Russian Federation",
    'Asia/Oral': "Kazakhstan",
    'Asia/Phnom_Penh': "Cambodia",
    'Asia/Pontianak': "Indonesia",
    'Asia/Pyongyang': "North Korea",
    'Asia/Qatar': "Qatar",
    'Asia/Qyzylorda': "Kazakhstan",
    'Asia/Rangoon': "Myanmar",
    'Asia/Riyadh': "Saudi Arabia",
    'Asia/Sakhalin': "Russian Federation",
    'Asia/Samarkand': "Uzbekistan",
    'Asia/Seoul': "Korea",
    'Asia/Shanghai': "China",
    'Asia/Singapore': "Singapore",
    'Asia/Taipei': "Taiwan",
    'Asia/Tashkent': "Uzbekistan",
    'Asia/Tbilisi': "Georgia",
    'Asia/Tehran': "Iran (Islamic Republic Of)",
    'Asia/Thimphu': "Bhutan",
    'Asia/Tokyo': "Japan",
    'Asia/Ulaanbaatar': "Mongolia",
    'Asia/Urumqi': "China",
    'Asia/Ust-Nera': "Russian Federation",
    'Asia/Vientiane': "Lao People's Democratic Republic",
    'Asia/Vladivostok': "Russian Federation",
    'Asia/Yakutsk': "Russian Federation",
    'Asia/Yekaterinburg': "Russian Federation",
    'Asia/Yerevan': "Armenia",
    'Atlantic/Azores': "Portugal",
    'Atlantic/Bermuda': "Bermuda",
    'Atlantic/Canary': "Spain",
    'Atlantic/Cape_Verde': "Cape Verde",
    'Atlantic/Faroe': "Faroe Islands",
    'Atlantic/Madeira': "Portugal",
    'Atlantic/Reykjavik': "Iceland",
    'Atlantic/South_Georgia': "South Georgia And Sandwich Isl.",
    'Atlantic/St_Helena': "Saint Helena",
    'Atlantic/Stanley': "Falkland Islands (Malvinas)",
    'Australia/Adelaide': "Australia",
    'Australia/Brisbane': "Australia",
    'Australia/Broken_Hill': "Australia",
    'Australia/Currie': "Australia",
    'Australia/Darwin': "Australia",
    'Australia/Eucla': "Australia",
    'Australia/Hobart': "Australia",
    'Australia/Lindeman': "Australia",
    'Australia/Lord_Howe': "Australia",
    'Australia/Melbourne': "Australia",
    'Australia/Perth': "Australia",
    'Australia/Sydney': "Australia",
    'Europe/Amsterdam': "Netherlands",
    'Europe/Andorra': "Andorra",
    'Europe/Athens': "Greece",
    'Europe/Belgrade': "Serbia",
    'Europe/Berlin': "Germany",
    'Europe/Bratislava': "Slovakia",
    'Europe/Brussels': "Belgium",
    'Europe/Bucharest': "Romania",
    'Europe/Budapest': "Hungary",
    'Europe/Busingen': "Germany",
    'Europe/Chisinau': "Moldova",
    'Europe/Copenhagen': "Denmark",
    'Europe/Dublin': "Ireland",
    'Europe/Gibraltar': "Gibraltar",
    'Europe/Guernsey': "Guernsey",
    'Europe/Helsinki': "Finland",
    'Europe/Isle_of_Man': "Isle Of Man",
    'Europe/Istanbul': "Turkey",
    'Europe/Jersey': "Jersey",
    'Europe/Kaliningrad': "Russian Federation",
    'Europe/Kiev': "Ukraine",
    'Europe/Lisbon': "Portugal",
    'Europe/Ljubljana': "Slovenia",
    'Europe/London': "United Kingdom",
    'Europe/Luxembourg': "Luxembourg",
    'Europe/Madrid': "Spain",
    'Europe/Malta': "Malta",
    'Europe/Mariehamn': "Aland Islands",
    'Europe/Minsk': "Belarus",
    'Europe/Monaco': "Monaco",
    'Europe/Moscow': "Russian Federation",
    'Europe/Oslo': "Norway",
    'Europe/Paris': "France",
    'Europe/Podgorica': "Montenegro",
    'Europe/Prague': "Czech Republic",
    'Europe/Riga': "Latvia",
    'Europe/Rome': "Italy",
    'Europe/Samara': "Russian Federation",
    'Europe/San_Marino': "San Marino",
    'Europe/Sarajevo': "Bosnia And Herzegovina",
    'Europe/Simferopol': "Russian Federation",
    'Europe/Skopje': "Macedonia",
    'Europe/Sofia': "Bulgaria",
    'Europe/Stockholm': "Sweden",
    'Europe/Tallinn': "Estonia",
    'Europe/Tirane': "Albania",
    'Europe/Uzhgorod': "Ukraine",
    'Europe/Vaduz': "Liechtenstein",
    'Europe/Vatican': "Holy See (Vatican City State)",
    'Europe/Vienna': "Austria",
    'Europe/Vilnius': "Lithuania",
    'Europe/Volgograd': "Russian Federation",
    'Europe/Warsaw': "Poland",
    'Europe/Zagreb': "Croatia",
    'Europe/Zaporozhye': "Ukraine",
    'Europe/Zurich': "Switzerland",
    'Indian/Antananarivo': "Madagascar",
    'Indian/Chagos': "British Indian Ocean Territory",
    'Indian/Christmas': "Christmas Island",
    'Indian/Cocos': "Cocos (Keeling) Islands",
    'Indian/Comoro': "Comoros",
    'Indian/Kerguelen': "French Southern Territories",
    'Indian/Mahe': "Seychelles",
    'Indian/Maldives': "Maldives",
    'Indian/Mauritius': "Mauritius",
    'Indian/Mayotte': "Mayotte",
    'Indian/Reunion': "Reunion",
    'Pacific/Apia': "Samoa",
    'Pacific/Auckland': "New Zealand",
    'Pacific/Chatham': "New Zealand",
    'Pacific/Chuuk': "Micronesia (Federated States Of)",
    'Pacific/Easter': "Chile",
    'Pacific/Efate': "Vanuatu",
    'Pacific/Enderbury': "Kiribati",
    'Pacific/Fakaofo': "Tokelau",
    'Pacific/Fiji': "Fiji",
    'Pacific/Funafuti': "Tuvalu",
    'Pacific/Galapagos': "Ecuador",
    'Pacific/Gambier': "French Polynesia",
    'Pacific/Guadalcanal': "Solomon Islands",
    'Pacific/Guam': "Guam",
    'Pacific/Honolulu': "United States",
    'Pacific/Johnston': "United States Outlying Islands",
    'Pacific/Kiritimati': "Kiribati",
    'Pacific/Kosrae': "Micronesia (Federated States Of)",
    'Pacific/Kwajalein': "Marshall Islands",
    'Pacific/Majuro': "Marshall Islands",
    'Pacific/Marquesas': "French Polynesia",
    'Pacific/Midway': "United States Outlying Islands",
    'Pacific/Nauru': "Nauru",
    'Pacific/Niue': "Niue",
    'Pacific/Norfolk': "Norfolk Island",
    'Pacific/Noumea': "New Caledonia",
    'Pacific/Pago_Pago': "American Samoa",
    'Pacific/Palau': "Palau",
    'Pacific/Pitcairn': "Pitcairn",
    'Pacific/Pohnpei': "Micronesia (Federated States Of)",
    'Pacific/Port_Moresby': "Papua New Guinea",
    'Pacific/Rarotonga': "Cook Islands",
    'Pacific/Saipan': "Northern Mariana Islands",
    'Pacific/Tahiti': "French Polynesia",
    'Pacific/Tarawa': "Kiribati",
    'Pacific/Tongatapu': "Tonga",
    'Pacific/Wake': "United States Outlying Islands",
    'Pacific/Wallis': "Wallis And Futuna",
};
